import bg_5f from "@/assets/images/bg8.jpg";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            `url(${bg_5f})`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65" />

      {/* Decorative blobs */}
      <div className="absolute top-1/4 left-10 w-64 h-64 rounded-full bg-[#5FA8D3]/20 blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-10 w-80 h-80 rounded-full bg-[#F78FB3]/20 blur-3xl pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 w-full max-w-4xl mx-auto">
        {/* Tagline pill */}
        <div
          className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          style={{ transitionDelay: "0ms" }}
        >
          <span className="inline-block px-5 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white/90 text-sm font-medium tracking-widest uppercase mb-6 border border-white/30">
            Home &bull; Decor &bull; Lifestyle
          </span>
        </div>

        {/* Headline */}
        <div
          className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          style={{ transitionDelay: "150ms" }}
        >
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Curated Gifts<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#7ec8eb] to-[#f0789e]">
              for Every Occasion
            </span>
          </h1>
        </div>

        {/* Subtext */}
        <div
          className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          style={{ transitionDelay: "300ms" }}
        >
          <p className="text-lg lg:text-xl text-white/80 max-w-xl mx-auto mb-10 leading-relaxed">
            Thoughtfully designed home decor and lifestyle products that make every moment truly special
          </p>
        </div>

        {/* CTAs */}
        <div
          className={`transition-all duration-700 flex flex-col sm:flex-row items-center justify-center gap-4 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          style={{ transitionDelay: "450ms" }}
        >
          <Link
            to="/products"
            className="px-8 py-4 rounded-full bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] text-white font-semibold text-base hover:opacity-90 hover:-translate-y-0.5 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Products
            <i className="ri-arrow-right-line ml-2" />
          </Link>
          <Link
            to="/about"
            className="px-8 py-4 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-base border border-white/40 hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Our Story
          </Link>
        </div>

        {/* Scroll hint */}
        <div
          className={`mt-16 transition-all duration-700 ${visible ? "opacity-100" : "opacity-0"}`}
          style={{ transitionDelay: "600ms" }}
        >
          <div className="w-6 h-10 border-2 border-white/40 rounded-full mx-auto flex items-start justify-center pt-1.5">
            <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
